// client/src/pages/SignupStepOne.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';
import { validatePassword } from '../utils/passwordPolicy';
import GradientButton from '../components/GradientButton';

const SignupStepOne = () => {
  const navigate = useNavigate();

// Vibe Pixel for Signup Page - Track Lead
  useEffect(() => {
    /* eslint-disable no-unused-expressions, no-sequences, new-parens */
    !function(v,i,b,e,c,o){if(!v[c]){var s=v[c]=function(){s.process?s.process.apply(s,arguments):s.queue.push(arguments)};s.queue=[],s.b=1*new Date;var t=i.createElement(b);t.async=!0,t.src=e;var n=i.getElementsByTagName(b)[0];n.parentNode.insertBefore(t,n)}}(window,document,"script","https://s.vibe.co/vbpx.js","vbpx");
    /* eslint-enable no-unused-expressions, no-sequences, new-parens */
    window.vbpx('init','5E1q8x');
    window.vbpx('event', 'lead');
  }, []);

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zip: '',
    city: '',
    state: '',
    password: '',
confirmPassword: ''
  });

  const [zipValid, setZipValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [isValidating, setIsValidating] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
const [passwordValid, setPasswordValid] = useState(false);
const [passwordErrors, setPasswordErrors] = useState([]);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [duplicateFields, setDuplicateFields] = useState({ email: false, phone: false });

  const validAreaCodes = [
  '201','202','203','205','206','207','208','209','210','212','213','214','215','216','217','218','219',
  '224','225','227','228','229','231','234','239','240','248','251','252','253','254','256','260','262',
  '267','269','270','272','274','276','281','301','302','303','304','305','307','308','309','310','312',
  '313','314','315','316','317','318','319','320','321','323','325','330','331','334','336','337','339',
  '346','347','351','352','360','361','364','380','385','386','401','402','404','405','406','407','408',
  '409','410','412','413','414','415','417','419','423','424','425','430','432','434','435','440','442',
  '443','447','458','463','464','469','470','475','478','479','480','484','501','502','503','504','505',
  '507','508','509','510','512','513','515','516','517','518','520','530','531','534','539','540','541',
  '551','559','561','562','563','564','567','570','571','573','574','575','580','585','586','601','602',
  '603','605','606','607','608','609','610','612','614','615','616','617','618','619','620','623','626',
  '628','629','630','631','636','641','646','650','651','657','660','661','662','667','669','678','681',
  '682','701','702','703','704','706','707','708','712','713','714','715','716','717','718','719','720',
  '724','725','726','727','730','731','732','734','737','740','743','747','754','757','758','760','762',
  '763','765','769','770','772','773','774','775','779','781','785','786','801','802','803','804','805',
  '806','808','810','812','813','814','815','816','817','818','828','830','831','832','838','839','840',
  '843','845','847','848','850','854','856','857','858','859','860','862','863','864','865','870','872',
  '878','901','903','904','906','907','908','909','910','912','913','914','915','916','917','918','919',
  '920','925','928','929','930','931','934','936','937','938','939','940','941','947','949','951','952',
  '954','956','959','970','971','972','973','975','978','979','980','984','985','986','989'
];

  // ✅ Function to capitalize first letter
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

// ✅ Password validation lives in utils/passwordPolicy.js (shared with ProfilePage)

const handlePasswordBlur = () => {
  const errors = validatePassword(form.password);
  setPasswordErrors(errors);
  setPasswordValid(errors.length === 0);
  setShowConfirmPassword(errors.length === 0);
  if (errors.length > 0) {
    setForm(prev => ({ ...prev, confirmPassword: '' }));
    setPasswordsMatch(false);
  }
};

const handleConfirmPasswordChange = (value) => {
  setForm(prev => ({ ...prev, confirmPassword: value }));
  setPasswordsMatch(value === form.password && value.length > 0);
};

const handlePasswordKeyDown = (e) => {
  if (e.key === 'Enter' || e.key === 'Tab') {
    handlePasswordBlur();
  }
};

  // ✅ Handle blur event to capitalize names
  const handleNameBlur = (e) => {
    const { name, value } = e.target;
    if (name === 'firstName' || name === 'lastName') {
      setForm({ ...form, [name]: capitalizeFirstLetter(value) });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const cleaned = value.replace(/\D/g, '').slice(0, 10);
      const formatted =
        cleaned.length < 4
          ? cleaned
          : cleaned.length < 7
          ? `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`
          : `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;

      setForm({ ...form, phone: formatted });

      if (cleaned.length >= 3) {
        const areaCode = cleaned.slice(0, 3);
        setPhoneValid(validAreaCodes.includes(areaCode));
      } else {
        setPhoneValid(true);
      }
    } else if (name === 'zip') {
      const zip = value.slice(0, 5);
      setForm({ ...form, zip });

      if (zip.length === 5) {
        fetch(`https://api.zippopotam.us/us/${zip}`)
          .then((res) => {
            if (!res.ok) throw new Error('Invalid ZIP');
            return res.json();
          })
          .then((data) => {
            setForm((prev) => ({
              ...prev,
              zip,
              city: data.places[0]['place name'],
              state: data.places[0]['state abbreviation']
            }));
            setZipValid(true);
          })
          .catch(() => {
            setZipValid(false);
            setForm((prev) => ({
              ...prev,
              zip: '',
              city: '',
              state: ''
            }));
          });
      }
 } else if (name === 'password') {
  setForm({ ...form, [name]: value });
  if (!value) {
    setPasswordValid(false);
    setShowConfirmPassword(false);
    setPasswordErrors([]);
  }
} else if (name === 'confirmPassword') {
  handleConfirmPasswordChange(value);
} else {
  setForm({ ...form, [name]: value });
}
  };

  // ✅ NEW: Validate against server for duplicates
  const validateSignupData = async () => {
    try {
      setIsValidating(true);
      console.log('🔍 Validating signup data...');

      const response = await fetch(apiUrl('validateSignupData'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: form.email,
          phone: form.phone,
        }),
      });

      const result = await response.json();
      console.log('✅ Validation result:', result);

      if (!result.valid) {
        // Prepare error message based on what's duplicate
        let message = '';
        const duplicates = { email: result.emailDuplicate, phone: result.phoneDuplicate };
        
        if (result.emailDuplicate && result.phoneDuplicate) {
          message = 'This email and phone number are already associated with LuckyLogic.ai accounts. You must use different email and phone number to sign up.';
        } else if (result.emailDuplicate) {
          message = 'This email is already associated with a LuckyLogic.ai account. You must use a different email to sign up.';
        } else if (result.phoneDuplicate) {
          message = 'This phone number is already associated with a LuckyLogic.ai account. You must use a different phone number to sign up.';
        }

        setErrorMessage(message);
        setDuplicateFields(duplicates);
        setShowErrorPopup(true);
        return false;
      }

      return true;
    } catch (error) {
      console.error('❌ Validation error:', error);
      setErrorMessage('Unable to validate signup data. Please try again.');
      setShowErrorPopup(true);
      return false;
    } finally {
      setIsValidating(false);
    }
  };

  // ✅ Handle error popup OK button
  const handleErrorOK = () => {
    setShowErrorPopup(false);
    
    // Clear the duplicate fields
    const newForm = { ...form };
    if (duplicateFields.email) {
      newForm.email = '';
    }
    if (duplicateFields.phone) {
      newForm.phone = '';
    }
    setForm(newForm);
    
    // Reset duplicate tracking
    setDuplicateFields({ email: false, phone: false });
    setErrorMessage('');
  };

  const handleNext = async (e) => {
    e.preventDefault();
    
    // Basic validation first
if (!passwordValid) {
  return;
}

if (!passwordsMatch) {
  return;
}

if (!zipValid || !form.zip || !form.city || !form.state) {
  alert('Please enter a valid ZIP code to proceed.');
  return;
}

if (!phoneValid || !form.phone) {
  alert('Please enter a valid U.S. phone number to proceed.');
  return;
}

    // ✅ NEW: Server-side duplicate validation
    const isValid = await validateSignupData();
    if (!isValid) {
      return; // Stop here if validation failed
    }

    // If validation passes, proceed as before.
    // Use sessionStorage (NOT localStorage) so signup data — especially the
    // password — is scoped to this tab and cleared when it closes.
    sessionStorage.setItem('lottoSignupData', JSON.stringify(form));
    // Store credentials separately for auto-signin after payment
    sessionStorage.setItem('signupEmail', form.email);
    sessionStorage.setItem('signupPassword', form.password);
    navigate('/signup/terms');
  };

  return (
    <>
      {/* ✅ Error Popup Overlay */}
      {showErrorPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center',
          }}>
            <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>Account Already Exists</h3>
            <p style={{ marginBottom: '1.5rem', lineHeight: '1.5' }}>{errorMessage}</p>
            <button 
              onClick={handleErrorOK}
              style={{
                padding: '0.75rem 2rem',
                backgroundColor: '#e74c3c',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 'bold',
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <div style={{
        backgroundColor: '#f8fafc',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem 1rem'
      }}>
        <div style={{
          fontFamily: 'Arial, sans-serif',
          maxWidth: '450px',
          width: '100%',
          padding: '2rem',
          backgroundColor: '#fff',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e5e7eb'
        }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Step 1: Basic Info</h2>

          <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <input 
              name="firstName" 
              placeholder="First Name" 
              value={form.firstName} 
              onChange={handleChange} 
              onBlur={handleNameBlur}
              required 
              style={inputStyle} 
            />
            <input 
              name="lastName" 
              placeholder="Last Name" 
              value={form.lastName} 
              onChange={handleChange} 
              onBlur={handleNameBlur}
              required 
              style={inputStyle} 
            />
            <input 
              name="email" 
              type="email" 
              placeholder="Email" 
              value={form.email} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
              autoCapitalize="none" 
              autoCorrect="off" 
            />
            <input 
              name="phone" 
              placeholder="Phone (e.g. 123-456-7890)" 
              value={form.phone} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
              inputMode="numeric" 
              pattern="[0-9-]*" 
            />
            {!phoneValid && <p style={{ color: 'red', fontSize: '0.9rem' }}>Please enter a valid U.S. phone number.</p>}
            <input 
              name="zip" 
              placeholder="ZIP Code" 
              value={form.zip} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
              inputMode="numeric" 
              pattern="[0-9]*" 
            />
            {!zipValid && <p style={{ color: 'red', fontSize: '0.9rem' }}>Please enter a valid U.S. ZIP code.</p>}
            <input 
              name="city" 
              placeholder="City" 
              value={form.city} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
            <input 
              name="state" 
              placeholder="State" 
              value={form.state} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
           <input
  name="password"
  type="password"
  placeholder="Create Password"
  value={form.password} 
  onChange={handleChange} 
  onBlur={handlePasswordBlur} onKeyDown={handlePasswordKeyDown}
  required 
  style={inputStyle} 
/>
{passwordErrors.length > 0 && (
  <div style={{
    color: '#e74c3c',
    fontSize: '0.9rem',
    backgroundColor: '#ffeaea',
    padding: '0.75rem',
    border: '1px solid #e74c3c',
    borderRadius: '4px',
    marginTop: '0rem'
  }}>
    <strong>Password must have:</strong>
    <ul style={{ margin: '0.5rem 0 0 1rem', paddingLeft: 0 }}>
      {passwordErrors.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </ul>
  </div>
)}

{showConfirmPassword && (
  <input
    name="confirmPassword"
    type="password"
    placeholder="Re-type Password"
    value={form.confirmPassword} 
    onChange={handleChange} 
    required 
    style={{
      ...inputStyle,
      borderColor: passwordsMatch ? '#27ae60' : '#e74c3c'
    }} 
  />
)}
{showConfirmPassword && !passwordsMatch && form.confirmPassword && (
  <p style={{ color: '#e74c3c', fontSize: '0.9rem', marginTop: '-0.5rem' }}>
    Passwords do not match
  </p>
)}

            {/* ✅ Twilio Compliance Message */}
            <div style={{
              fontSize: '0.85rem',
              color: '#444',
              backgroundColor: '#f9f9f9',
              padding: '1rem',
              border: '1px solid #ccc',
              borderRadius: '6px',
              marginTop: '1.5rem'
            }}>
              By signing up, you agree to receive automated email and text messages from LuckyLogic.ai. Message and data rates may apply. You can choose your communication preferences during this signup or change them in your member profile anytime once you have an active account.  You can also reply "STOP" on any text message to stop messaging.  See our <a href="/terms" style={{ color: '#007bff' }}>Terms</a> and <a href="/privacy" style={{ color: '#007bff' }}>Privacy Policy</a> for more information.
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '1rem 0' }}>
              <GradientButton
                variant="green"
                type="submit"
                disabled={isValidating}
                style={{
                  opacity: isValidating ? 0.7 : 1,
                  cursor: isValidating ? 'not-allowed' : 'pointer',
                }}
              >
                {isValidating ? 'Validating...' : 'Next'}
              </GradientButton>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

const inputStyle = {
  padding: '0.75rem',
  borderRadius: '4px',
  border: '1px solid #ccc',
  width: '100%',
  fontSize: '16px' // Prevents zoom on iOS
};

export default SignupStepOne;